<template>
	<div class="holder">
		<div class="label" v-if="label">{{ innerLabel }}</div>
		<vue-date-picker
			v-model="innerValue"
			@input="onInput"
			:attributes="attributes"
			:max-date="new Date()"
			:popover="{ visibility: 'focus' }"
			color="indigo"
		>
			<template v-slot="{ inputValue, inputEvents }">
				<input :value="inputValue" v-on="inputEvents" />
			</template>
		</vue-date-picker>
	</div>
</template>

<script>
export default {
	name: 'uiInput',
	props: {
		value: {
			type: [String, Number, Date],
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		label: [Boolean, String],
	},
	data() {
		return {
			innerValue: this.value,
			attributes: [
				{
					key: 'today',
					dot: 'red',
					dates: new Date(),
				},
			],
		}
	},
	computed: {
		innerLabel() {
			if (!this.label) return
			if (typeof this.label === 'string') return this.label
			return this.placeholder
		},
	},
	methods: {
		onInput(e) {
			this.$emit('input', e)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.holder {
	width: 100%;
	display: block;
}

.label {
	font-size: 14px;
	opacity: 0.5;
	margin-bottom: 3px;
}

input {
	display: block;
	width: 100%;
	padding: 16px 20px;
	background-color: transparent;
	border: none;
	background: @grey;
	border-radius: 10px;
	font-size: 15px;
	box-sizing: border-box;
	outline: none;

	&::placeholder {
		color: rgba(0, 0, 0, 0.3);
		transition: color 0.2s;
	}

	&:focus {
		&::placeholder {
			color: transparent;
		}
	}
}
</style>
